import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaCheckCircle } from 'react-icons/fa';
import './Services.css';
import { Helmet } from 'react-helmet';

const Services = () => {
  const services = [
    {
      // icon: '🏸',
      title: 'Professional Badminton Coaching',
      description: 'Our professional coaching service is led by experienced and qualified badminton coaches who focus on correct techniques, footwork, shot accuracy, and match strategies. Each training session is structured to ensure steady improvement, skill refinement, and performance consistency for players of all levels.',
      features: [],
      link: '/services/coaching-programs'
    },
    {
      title: 'Beginner Training Program',
      description: 'This program is specially designed for players who are new to badminton. It focuses on building strong fundamentals such as grip, basic strokes, foot movement, court awareness, and rules of the game. The training is conducted in a friendly and encouraging environment to build confidence and interest in the sport.',
      features: [],
      link: '/services/coaching-programs'
    },
    {
      title: 'Intermediate Skill Development Program',
      description: 'For players with basic badminton knowledge, this service helps improve technical skills and gameplay understanding. Training includes advanced strokes, better footwork coordination, speed enhancement, and tactical drills to prepare players for competitive play.',
      features: [],
      link: '/services/coaching-programs'
    },
    {
      title: 'Advanced & Competitive Training',
      description: 'Our advanced training service is designed for serious and tournament-level players. It includes high-intensity drills, match simulations, advanced strategies, and performance analysis. Players are trained to compete confidently in district, state, and higher-level tournaments.',
      features: [],
      link: '/services/coaching-programs'
    },
    {
      title: 'Private & One-to-One Coaching',
      description: 'This personalized coaching service offers individual attention tailored to a player’s specific needs and goals. Private sessions focus on correcting weaknesses, improving techniques, and accelerating performance improvement through customized training plans.',
      features: [],
      link: '/services/coaching-programs'
    },
    {
      title: 'Fitness & Physical Conditioning',
      description: 'Badminton demands speed, agility, stamina, and strength. Our fitness training service includes strength conditioning, endurance training, agility drills, flexibility exercises, and injury prevention routines. This service helps players improve overall athletic performance and reduce injury risks.',
      features: [],
      link: '/services/membership'
    },
    {
      title: 'Match Practice & Game Strategy Sessions',
      description: 'We provide dedicated match practice sessions where players experience real-game situations. These sessions help players improve decision-making, shot selection, court positioning, and mental toughness while playing under match pressure.',
      features: [],
      link: '/contact'
    },
    {
      title: 'Youth & Grassroots Development Program',
      description: 'Our youth development service focuses on identifying and nurturing young talent at an early age. Training emphasizes fun-based learning, coordination, basic skills, discipline, and long-term development, laying a strong foundation for future competitive success.',
      features: [],
      link: '/services/facilities'
    },
    {
      title: 'Tournament Preparation & Guidance',
      description: 'Comprehensive physical conditioning to enhance your on-court performance.',
      features: [],
      link: '/services/facilities'
    },
  ];

  return (
    <>
      <Helmet>
        <title>Our Services</title>
      </Helmet>
      <div className="services-page">
        <div className="page-header">
          <div className="container">
            <h1>Our Services</h1>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Services</span>
            </div>
          </div>
        </div>

        <section className="services-intro section">
          <div className="container">
            <div className="section-title">
              <h2>Comprehensive Training Programs</h2>
              <p>
                From beginners to professionals, we have programs designed to help every player
                reach their full potential. Explore our range of services below.
              </p>
            </div>
          </div>
        </section>

        <section className="services-list section bg-light">
          <div className="container">
            <div className="services-grid-full">
              {services.map((service, index) => (
                <div key={index} className="service-card-full">
                  <div className="service-icon-large">{service.icon}</div>
                  <div className="service-content">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <ul className="service-features">
                      {service.features.map((feature, idx) => (
                        <li key={idx}>
                          <FaCheckCircle />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <Link to={service.link} className="btn btn-primary btn-sm">
                      Learn More <FaArrowRight />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="services-cta section">
          <div className="container">
            <div className="cta-box">
              <h2>Not Sure Which Program Is Right for You?</h2>
              <p>
                Our team can help you choose the perfect program based on your goals,
                skill level, and schedule. Book a free consultation today!
              </p>
              <div className="cta-buttons">
                <Link to="/contact" className="btn btn-accent">
                  Book Free Consultation <FaArrowRight />
                </Link>
                <a href="tel:+919876543210" className="btn btn-secondary">
                  Call: +91 98765 43210
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Services;
